import React, { SetStateAction, useCallback, useEffect, useState } from "react";
import Field from "../../common/Field";
import axios from "axios";
import "./formStyles.css";
import { objectToFormData } from "object-to-formdata";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AddIcon from "@material-ui/icons/Add";
import { validateEmail } from "../../utils/email";

import {
  AntecedenteField,
  Antecedente,
  useTextField,
  useSelectField,
  useDateField,
  useTimeField,
  useForm,
} from "../../common/Form";
import { convert, LocalDate, LocalDateTime } from "js-joda";
import { List } from "immutable";
import { Attachment, FileField } from "../../common/attachments";
import { handleCreateConcursoError } from "../../utils/errors";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const tzOffset = new Date().getTimezoneOffset() * 60000;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

type Facultad = {
  id: number;
  nombre: string;
};

type Contacto = {
  id: number;
  nombres: string;
  paterno: string;
  materno: string;
};

export type AntecedenteDefault = {
  id: number;
  nombre: string;
  obligatorio: string;
  isValid: boolean;
};

type AtfileDefault = {
  id: number;
  nombre: string;
  archivo: string;
};

type defaultDataType = {
  codigo: string;
  nombre: string;
  fecha_inicio: string;
  fecha_termino: string;
  id_facultad: string;
  nombre_facultad: string;
  id_contacto: string;
  fecha_aviso_diario: string;
  comentario: string;
  archivos: AtfileDefault[];
  antecedentes: AntecedenteDefault[];
};

type MantenedorProps = {
  handleModal: () => void;
  concursoId: string;
  title: string;
  saveDraft: boolean;
  defaultData: defaultDataType | any;
  disableOnInvalid: boolean;
  sitio: string;
  fatherSetOpenSpinner: (openSpinner) => void;
  fatherSetOpen: (open) => void;
};

const Mantenedor: React.FC<MantenedorProps> = (props) => {
  const defaultData = props.defaultData || null;
  const saveDraft = props.saveDraft || false;
  const [facultades, setFacultades] = useState([]);
  const [contactos, setContactos] = useState([]);
  const [open, setOpen] = useState(false);
  const [openSpinner, setOpenSpinner] = React.useState(false);
  const fatherSetOpenSpinner = props.fatherSetOpenSpinner;
  const fatherSetOpen = props.fatherSetOpen;
  const [id_fac, set_id_fac] = useState("");

  const showSpinner = () => {
    setOpenSpinner(true);
  };

  const handleError = (error) => {
    fatherSetOpenSpinner(false);
    fatherSetOpen(false);
    handleCreateConcursoError(error);
  };

  useEffect(() => {
    if (!saveDraft) {
      fatherSetOpenSpinner(true);
      axios
        .get((window as any).ENV.API_URL + "/facultades/")
        .then((res) => {
          setFacultades(res.data);
          fatherSetOpenSpinner(false);
          setOpen(true);
        })
        //todo mostrar mensajes de error
        .catch((error) => handleError(error));
    } else {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    axios
      .get(
        (window as any).ENV.API_URL +
        "/contactos/" +
        (defaultData ? defaultData.id_facultad : id_fac) +
        "/"
      )
      .then((res) => {
        setContactos(res.data);
      });
  }, [id_fac]);

  const update_contactos = (id) => {
    set_id_fac(id);
  };

  // Form
  const codigo = useTextField({
    label: "Código",
    fullWidth: true,
    defaultValue: defaultData ? defaultData.codigo : "",
    disabled: true,
  });

  const nombreConcursoField = useTextField({
    label: "Nombre del concurso",
    fullWidth: true,
    defaultValue: defaultData ? defaultData.nombre : "",
  });

  const nombreContactoField = useTextField({
    label: "Nombre del contacto",
    fullWidth: true,
    defaultValue: defaultData ? defaultData.nombre_contacto : "",
  });
  const mailContactoField = useTextField({
    label: "E-mail del contacto",
    fullWidth: true,
    defaultValue: defaultData ? defaultData.correo_contacto : "",
    validate(value: string): string {
      return validateEmail(value);
    },
  });
  const inicioDate = new Date(new Date(defaultData?.fecha_inicio).getTime());
  const inicioTime = new Date(
    new Date(defaultData?.fecha_inicio).getTime() - tzOffset
  );
  const fechaAperturaField = useDateField({
    label: "Fecha de apertura",
    disablePast: true,
    defaultValue: defaultData?.fecha_inicio
      ? LocalDate.parse(new Date(inicioDate).toISOString().substring(0, 10))
      : undefined,
  });
  const horaAperturaField = useTimeField({
    label: "Hora de apertura",
    defaultValue: defaultData?.fecha_inicio
      ? LocalDateTime.parse(new Date(inicioTime).toISOString().substring(0, 23))
      : undefined,
  });
  const cierreDate = new Date(new Date(defaultData?.fecha_termino).getTime());
  const cierreTime = new Date(
    new Date(defaultData?.fecha_termino).getTime() - tzOffset
  );
  const fechaCierreField = useDateField({
    label: "Fecha de cierre",
    disablePast: true,
    defaultValue: defaultData?.fecha_termino
      ? LocalDate.parse(new Date(cierreDate).toISOString().substring(0, 10))
      : undefined,
    validate(date: LocalDate): string {
      const apertura = fechaAperturaField.value;
      if (apertura && date.isBefore(apertura)) {
        return "Debe elegir una fecha posterior a la apertura";
      } else {
        return "OK";
      }
    },
  });
  const horaCierreField = useTimeField({
    label: "Hora de cierre",
    defaultValue: defaultData?.fecha_termino
      ? LocalDateTime.parse(new Date(cierreTime).toISOString().substring(0, 23))
      : undefined,
  });
  const fechaAvisoDiarioField = useDateField({
    label: "Fecha de aviso diario",
    defaultValue: defaultData?.fecha_aviso_diario
      ? LocalDate.parse(
        new Date(defaultData.fecha_aviso_diario)
          .toISOString()
          .substring(0, 10)
      )
      : undefined,
    validate(date: LocalDate): string {
      const apertura = fechaAperturaField.value;
      if (apertura && date.isAfter(apertura)) {
        return "La fecha de aviso no puede ser posterior a la fecha de apertura";
      } else {
        return "OK";
      }
    },
  });

  const nombreFacultadField = useSelectField({
    label: "Facultad",
    disabled: saveDraft,
    defaultValue: defaultData ? defaultData.id_facultad : "",
    onChange: (event: any) => {
      update_contactos(event.target.value);
    },
    options: defaultData
      ? [{ value: defaultData.id_facultad, label: defaultData.nombre_facultad }]
      : facultades.map((fac: Facultad) => ({
        value: fac.id.toString(),
        label: fac.nombre,
      })),
  });

  /**
  const contactoField = useSelectField({
    label: "Contacto",
    defaultValue: defaultData ? defaultData.id_contacto : "",
    options: contactos.map((cont: Contacto) => ({
          value: cont.id.toString(),
          label: cont.nombres + " " + cont.paterno + " " + cont.materno,
        })),
  });
  */

  const mainForm = useForm([
    nombreConcursoField,
    nombreContactoField,
    mailContactoField,
    // contactoField,
    fechaAperturaField,
    fechaCierreField,
    horaCierreField,
    horaAperturaField,
    fechaAvisoDiarioField,
    nombreFacultadField,
  ]);

  const formatAntecedentes = (antecedentes: AntecedenteDefault[]) => {
    const arr: Antecedente[] = [];
    antecedentes.forEach((antecedente: AntecedenteDefault) => {
      arr.push({
        id: antecedente.id,
        nombre: antecedente.nombre,
        estado: antecedente.obligatorio ? "obligatorio" : "opcional",
        isValid: antecedente.isValid,
        eliminable: antecedente.nombre !== "Currículum",
        deleted: false,
      });
    });
    return arr;
  };

  // Antecedentes
  const [antecedentes, setAntecedentes] = useState<Antecedente[]>(
    defaultData?.antecedentes.length > 0
      ? formatAntecedentes(defaultData.antecedentes)
      : [
        {
          id: undefined,
          nombre: "Currículum",
          estado: "obligatorio",
          eliminable: false,
          isValid: true,
          deleted: false,
        },
        {
          id: undefined,
          nombre: "Declaración jurada",
          estado: "obligatorio",
          eliminable: true,
          isValid: true,
          deleted: false,
        },
      ]
  );

  const onClickAgregarAntecedente = useCallback(() => {
    const newAntecedente = {
      id: undefined,
      nombre: "",
      estado: "opcional",
      eliminable: true,
      isValid: false,
      deleted: false,
    };
    setAntecedentes((antecedentes) => [...antecedentes, newAntecedente]);
  }, []);

  const eliminarAntecedente = useCallback(
    (indexAntecedente: number) => {
      antecedentes[indexAntecedente].deleted = true;
      setAntecedentes([...antecedentes]);
    },
    [antecedentes]
  );

  // Archivos
  const [attachments, setAttachments] = useState(
    List<Attachment>(
      defaultData?.archivos
        ? defaultData.archivos.map(
          (atFile: AtfileDefault) =>
            new Attachment({
              id: atFile.id, // id from backend
              nombre: atFile.nombre,
              archivo: null,
              reactKey: atFile.id.toString(), // unique across all attachments
              deleted: false,
            })
        )
        : [
          new Attachment({
            id: undefined, // as it hasn't been uploaded to the backend yet
            nombre: "Bases del concurso",
            archivo: null,
            reactKey: Math.random().toString(), // unique across all attachments
            deleted: false,
          }),
          new Attachment({
            id: undefined, // as it hasn't been uploaded to the backend yet
            nombre: "Declaración jurada",
            archivo: null,
            reactKey: Math.random().toString(), // unique across all attachments
            deleted: false,
          }),
          new Attachment({
            id: undefined, // as it hasn't been uploaded to the backend yet
            nombre: "Tipo de currículum",
            archivo: null,
            reactKey: Math.random().toString(), // unique across all attachments
            deleted: false,
          }),
        ]
    )
  );

  function addAttachment() {
    setAttachments((list) => list.push(Attachment.empty()));
  }

   function updateAttachment(
    index: number,
    action: SetStateAction<Attachment>
  ): void {
    if (typeof action === "function") {
      const resp=(list) => list.update(index,  action);
      setAttachments(resp);
    } else {
      setAttachments((list) => list.set(index, action));
    }
  }

  const formsAreValid =
    mainForm.isValid &&
    attachments.every(
      (attachment) => attachment.isValid || Boolean(attachment.deleted)
    ) &&
    antecedentes.every((ante) => ante.isValid || Boolean(ante.deleted));

  // Concurso
  const concurso = {
    nombre: nombreConcursoField.value,
    fechaApertura: fechaAperturaField.value,
    fechaCierre: fechaCierreField.value,
    horaCierre: horaCierreField.value,
    horaApertura: horaAperturaField.value,
    fecha_aviso_diario: fechaAvisoDiarioField.value,
    nombreFacultad: nombreFacultadField.value,
    archivos: attachments.toArray(),
    id_usuario_contacto: "0180206779", //contactoField.value,
    nombre_contacto: nombreContactoField.value,
    correo_contacto: mailContactoField.value,
    antecedentes,
  };

  // Aviso de confirmacion
  const [openToast, setOpenToast] = React.useState(false);
  const [toastVariant, setToastVariant] = React.useState("error");
  const [toastContent, setToastContent] = React.useState("");

  const classes = useStyles();

  const hideSpinner = useCallback(
    (variant) => {
      setOpenSpinner(false);
      const contentSuccess = saveDraft ? "modificado" : "creado";
      const contentError = saveDraft ? "modificar" : "crear";
      switch (variant) {
        case "success":
          setOpenToast(true);
          setToastVariant(variant);
          setToastContent(`El concurso ha sido ${contentSuccess} con éxito.`);
          break;
        case "error":
          setOpenToast(true);
          setToastVariant(variant);
          setToastContent(
            `Ocurrió un error al intentar ${contentError} el concurso.`
          );
          break;
        default:
          setOpenToast(false);
          break;
      }
    },
    [saveDraft]
  );

  const onClickSolicitarPublicacion = useCallback(() => {
    showSpinner();
    const inicio = {
      date: convert(concurso.fechaApertura!)
        .toDate()
        .toISOString()
        .substring(0, 10),
      time: convert(concurso.horaApertura!)
        .toDate()
        .toISOString()
        .substring(11, 23),
    };
    const termino = {
      date: convert(concurso.fechaCierre!)
        .toDate()
        .toISOString()
        .substring(0, 10),
      time: convert(concurso.horaCierre!)
        .toDate()
        .toISOString()
        .substring(11, 23),
    };
    const json = {
      nombre: concurso.nombre,
      id_facultad: concurso.nombreFacultad,
      fecha_inicio: `${inicio.date}T${inicio.time}Z`,
      fecha_termino: `${termino.date}T${termino.time}Z`,
      fecha_aviso_diario: convert(concurso.fecha_aviso_diario!)
        .toDate()
        .toISOString(),
      id_usuario_creador: (window as any).User.Rut,
      id_usuario_contacto: "encanchar con api personas", //contactoField.value,
      nombre_contacto: concurso.nombre_contacto,
      correo_contacto: concurso.correo_contacto,
    };

    const formObj = {
      concurso: json,
      archivos: attachments.toArray(),
      antecedentes: antecedentes,
    };

    if (!saveDraft) {
      formObj.antecedentes = antecedentes.filter(
        (antecedente) => !antecedente.deleted
      );
      formObj.archivos = attachments
        .filter((attachment) => !attachment.deleted)
        .toArray();
    } else {
      formObj.antecedentes = antecedentes.filter(
        (antecedente) => antecedente.id || !antecedente.deleted
      );
      formObj.archivos = attachments
        .filter((attachment) => attachment.id || !attachment.deleted)
        .toArray();
    }

    const formData = objectToFormData(formObj);
    Object.entries(json).forEach(([key, value]) => {
      formData.set(key, `${value}`);
    });
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    const redirectSite =
      props.sitio == "creador"
        ? (window as any).ENV.URL_FRONT + "Concursos?tab=0"
        : (window as any).ENV.URL_FRONT + "AdminConcursos?tab=0";
    if (!saveDraft) {
      axios
        .post((window as any).ENV.API_URL + "/concursos/", formData, config)
        .then(() => {
          hideSpinner("success");
          setTimeout(() => {
            window.location.href = redirectSite;
          }, 1000);
        })
        .catch((err) => {
          hideSpinner("error");
          console.error(err);
        });
    } else {
      axios
        .put(
          (window as any).ENV.API_URL +
          "/concursosBorrador/" +
          props.concursoId +
          "/",
          formData,
          config
        )
        .then(() => {
          hideSpinner("success");
          setTimeout(() => {
            window.location.href = redirectSite;
          }, 1000);
        })
        .catch((err) => {
          hideSpinner("error");
          console.error(err);
        });
    }
  }, [
    concurso,
    attachments,
    antecedentes,
    saveDraft,
    hideSpinner,
    props.concursoId,
  ]);

  const title = props.title;
  const disableOnInvalid = props.disableOnInvalid;

  return (
    <React.Fragment>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent dividers={true}>
        {props?.defaultData?.comentario ? (
          <MuiAlert elevation={0} severity="warning" className="mb-3">
            {props.defaultData.comentario}
          </MuiAlert>
        ) : null}

        <h5>Información básica</h5>
        <p>Complete los campos con la información básica del concurso.</p>

        <Grid container>
          {saveDraft ? (
            <Grid item xs={12}>
              <Field>{codigo.render()}</Field>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <Field>{nombreConcursoField.render()}</Field>
          </Grid>
          <Grid item xs={12}>
            <Field>{nombreFacultadField.render()}</Field>
          </Grid>
          {/*
          <Grid item xs={12}>
            <Field>{contactoField.render()}</Field>
          </Grid>*/}
          <Grid container justify="space-between" spacing={3}>
            <Grid item xs={6}>
              <Field>{nombreContactoField.render()}</Field>
            </Grid>
            <Grid item xs={6}>
              <Field>{mailContactoField.render()}</Field>
            </Grid>
          </Grid>
          <Grid container justify="space-between" spacing={3}>
            <Grid item xs={6}>
              <Field>{fechaAvisoDiarioField.render()}</Field>
            </Grid>
          </Grid>
          <Grid container justify="space-between" spacing={3}>
            <Grid item xs={6}>
              <Field>{fechaAperturaField.render()}</Field>
            </Grid>
            <Grid item xs={6}>
              <Field>{horaAperturaField.render()}</Field>
            </Grid>
          </Grid>
          <Grid container justify="space-between" spacing={3}>
            <Grid item xs={6}>
              <Field>{fechaCierreField.render()}</Field>
            </Grid>
            <Grid item xs={6}>
              <Field>{horaCierreField.render()}</Field>
            </Grid>
          </Grid>
        </Grid>

        <h5 className="mt-3">Documentación</h5>
        <p>
          Añada los documentos que detallan el concurso (.pdf, .doc, .docx).{" "}
        </p>

        <div>
          {attachments.map((attachment, index) => (
            <FileField
              key={attachment.reactKey} // using index here causes bugs
              attachment={attachment}
              setAttachment={(action) => updateAttachment(index, action)}
            />
          ))}
          <Button
            color="primary"
            variant="outlined"
            className="mt-3"
            onClick={addAttachment}
            startIcon={<AddIcon />}
          >
            Agregar
          </Button>
        </div>

        <h5 className="mt-3">Antecedentes</h5>
        <p>Añada los documentos requeridos para cada postulante.</p>

        <div style={{ marginBottom: "1em" }}>
          {antecedentes.map((antecedente, indexAntecedente) =>
            antecedente ? (
              <AntecedenteField
                key={indexAntecedente}
                index={indexAntecedente}
                antecedentes={antecedentes}
                setAntecedentes={setAntecedentes}
                onDelete={() => eliminarAntecedente(indexAntecedente)}
              />
            ) : null
          )}
          <Button
            variant="outlined"
            color="primary"
            className="mt-3"
            onClick={onClickAgregarAntecedente}
            style={{
              borderRadius: "0.25em",
              fontSize: `${10 / 11}em`,
            }}
            startIcon={<AddIcon />}
          >
            Agregar
          </Button>
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          disableElevation
          className="mr-3"
          variant="contained"
          onClick={() => props.handleModal()}
        >
          Cancelar
        </Button>
        <Button
          disableElevation
          variant="contained"
          color="primary"
          onClick={onClickSolicitarPublicacion}
          disabled={disableOnInvalid ? !formsAreValid : false}
        >
          Guardar
        </Button>
      </DialogActions>
      <Backdrop className={classes.backdrop} open={openSpinner}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openToast}
        autoHideDuration={2000}
        onClose={() => setOpenToast(false)}
      >
        <Alert severity={toastVariant}>{toastContent}</Alert>
      </Snackbar>
    </React.Fragment>
  );
};
export default Mantenedor;
